import { Data, ExpEvalRequest, ExpEvalResult } from './types';

class JEXLService {
  sizeOf = (_data: Data, _attribute: string): number => {
    throw new Error(`[JEXLService] sizeOf is not implemented yet`);
  };

  evaluate = (_request: ExpEvalRequest): ExpEvalResult => {
    throw new Error(`[JEXLService] evaluate is not implemented yet`);
  };
}

const jexlService = new JEXLService();

export default jexlService;
